import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_BILLING_CODE_ID_LOADING = 'GET_BILLING_CODE_ID_LOADING';
export const GET_BILLING_CODE_ID_SUCCESS = 'GET_BILLING_CODE_ID_SUCCESS';
export const GET_BILLING_CODE_ID_REJECT = 'GET_BILLING_CODE_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getBillingCodeIdLoading = () => ({ type: GET_BILLING_CODE_ID_LOADING });
export const getBillingCodeIdSuccess = (payload) => ({ type: GET_BILLING_CODE_ID_SUCCESS, payload });
export const getBillingCodeIdReject = (payload) => ({ type: GET_BILLING_CODE_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getBillingCodeIdRequest = async (data = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params: { COD_FACTURA: data.id },
    }, getState);
    return request(`/BillingCode/web/GetBillingCodeById`, options);
};
